import {css, cx as addStyles} from '@emotion/css';
import React, {HTMLAttributes} from 'react';
import {theme} from './Common';
import {FacebookIcon, InstagramIcon, TwitterIcon, YelpIcon} from './Icons';

type SocialMedias = 'Facebook' | 'Yelp' | 'Instagram' | 'Twitter';
type Color = {color?: 'white' | 'blue'};
type Size = {size?: 'big' | 'small'};

export type EmailSocialMediaProps = {socialmedia: SocialMedias; url: string} & Color & Size;
export const EmailSocialMedia = ({socialmedia, url, ...rest}: EmailSocialMediaProps) => (
  <Container {...rest}>
    <a href={url} target='_blank' rel='noreferrer'>
      {socialmedia === 'Facebook' && <FacebookIcon color='inherit' />}
      {socialmedia === 'Instagram' && <InstagramIcon color='inherit' />}
      {socialmedia === 'Yelp' && <YelpIcon color='inherit' />}
      {socialmedia === 'Twitter' && <TwitterIcon color='inherit' />}
    </a>
  </Container>
);
const colorStyle = {
  white: css({background: theme.colors.white, svg: {color: theme.colors.darkBlue}}),
  blue: css({background: theme.colors.darkBlue, svg: {color: theme.colors.white}}),
};
const sizeStyle = {
  small: css({
    width: '24px',
    height: '24px',
    svg: {width: '17px', height: '17px', marginTop: '6px'},
  }),
  big: css({width: '48px', height: '48px', svg: {width: '32px', height: '32px', marginTop: '5px'}}),
};
const Container = ({
  color = 'white',
  size = 'small',
  ...rest
}: HTMLAttributes<HTMLDivElement> & Color & Size) => (
  <div
    className={addStyles(
      css({borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center'}),
      colorStyle[color],
      sizeStyle[size],
    )}
    {...rest}
  />
);
